/**
 * Petit tap tactile sur mobile — pour donner un retour physique à chaque action.
 *
 * Silencieux sur desktop (navigator.vibrate absent) et sur les navigateurs
 * qui ne supportent pas la Vibration API. Ne bloque jamais l'action.
 *
 * Usage :
 *   import { hapticTap, hapticSuccess, hapticWarn } from "../../lib/haptics";
 *   <button onClick={() => { hapticTap(); doSomething(); }}>...
 */

const canVibrate = () => typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

/** Tap léger — un feedback subtile (~15ms). Pour tous les boutons d'action. */
export function hapticTap() {
  if (canVibrate()) {
    try { navigator.vibrate(15); } catch { /* ignore */ }
  }
}

/** Feedback plus long pour une action positive (vente, contrat signé). */
export function hapticSuccess() {
  if (canVibrate()) {
    try { navigator.vibrate([30, 40, 30]); } catch { /* ignore */ }
  }
}

/** Vibration double pour une confirmation critique (DNC, désactivation). */
export function hapticWarn() {
  if (canVibrate()) {
    try { navigator.vibrate([50, 30, 50]); } catch { /* ignore */ }
  }
}
